import { D } from './tiles.js'

const H1 = ['2m', '3m', '4m', '7m', '8m', '9m', '3p', '5p', '8p', '8p', '4s', '6s', '9s']
const H2 = ['2m', '3m', '4m', '7m', '8m', '9m', '3p', '5p', '8p', '8p', '4s', '5s', '6s']
const LA = D('9m 1p 2s 3z')
const TA = D('2s 1m 6z')
const RA = D('1z 7z 9p')
const LB = D('9m 1p 2s 3z 1m 6z 9p 5m')
const TB = D('2s 1m 6z 9s 4m 1p 7z')
const RB = D('1z 7z 9p 2m 5s 8m 3p!')
const LC = LB.concat(D('2p'))
const TC = TB.concat(D('5p'))
const RC = D('1z 7z 9p 2m 5s 8m 3p 7p')

function P(name, wind, score, discards) {
  return { name, wind, score, riichi: false, discards, handCount: 13 }
}

export const LESSON_TITLE = 'When to riichi'

export const FRAMES = [
  {
    round: '東2局', turn: 4, wall: 45, sticks: 0, honba: 0, doraInd: '3s',
    title: 'Find your five blocks',
    body: '234m and 789m are complete, 88p is your pair, and this 5s draw finishes 456s. That is five blocks — everything else is extra. Cut 9s and you are tenpai on the 4p kanchan.',
    ukeire: null, win: false,
    hero: { score: 25000, riichi: false, hand: H1, draw: '5s', hl: ['9s'], discards: D('1z 9p 1s') },
    left: P('Kaori', '東', 26100, LA), top: P('Mio', '北', 24600, TA), right: P('Rin', '西', 24300, RA),
  },
  {
    round: '東2局', turn: 4, wall: 44, sticks: 1, honba: 0, doraInd: '3s',
    title: 'Riichi is your only yaku',
    body: 'Damaten earns nothing here: the 9m kills tanyao and the kanchan wait kills pinfu — the hand is yakuless. Declare riichi. With the 4s dora you start at 5,800, plus ippatsu and ura chances.',
    ukeire: { tiles: ['4p'], note: '4 tiles live' }, win: false,
    hero: { score: 24000, riichi: true, hand: H2, draw: null, hl: ['4s'], discards: D('1z 9p 1s 9sr!') },
    left: P('Kaori', '東', 26100, LA), top: P('Mio', '北', 24600, TA), right: P('Rin', '西', 24300, RA),
  },
  {
    round: '東2局', turn: 8, wall: 30, sticks: 1, honba: 0, doraInd: '3s',
    title: 'Track your wait',
    body: 'All four 4p are still live — none on the table — and your own pond has no 4p, so no furiten. Rin just cut 3p, so tiles around your wait are moving. Tsumogiri everything and let the wait work.',
    ukeire: { tiles: ['4p'], note: '4 live · no furiten' }, win: false,
    hero: { score: 24000, riichi: true, hand: H2, draw: null, discards: D('1z 9p 1s 9sr 6z 2s') },
    left: P('Kaori', '東', 26100, LB), top: P('Mio', '北', 24600, TB), right: P('Rin', '西', 24300, RB),
  },
  {
    round: '東2局', turn: 9, wall: 26, sticks: 1, honba: 0, doraInd: '3s',
    title: 'The payoff',
    body: 'Tsumo 4p. Riichi, menzen tsumo, dora 1 — 3 han 30 fu: 1,000/2,000, plus your riichi stick back and an ura chance. A four-tile kanchan is fine when riichi adds this much value.',
    ukeire: null, win: true,
    hero: { score: 24000, riichi: true, hand: H2, draw: '4p', drawHl: true, discards: D('1z 9p 1s 9sr 6z 2s') },
    left: P('Kaori', '東', 26100, LC), top: P('Mio', '北', 24600, TC), right: P('Rin', '西', 24300, RC),
  },
]
